import OperationsController from "../adapters/opentrip.controller";

const listTripsOpenTrips = async(payload) =>{
    const response = await OperationsController.listTripsOpenTrips(payload)
    return response;
}


export default listTripsOpenTrips;